<template>
  <div id="app">
    <homeT msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import homeT from './components/homeT.vue'

export default {
  name: 'App',
  components: {
    homeT
  }
}
</script>

<style>
*{
  padding:0;
  margin: 0;
}
</style>
